import axios from 'axios'
import { reset } from 'redux-form'
import { push } from 'react-router-redux'
import { openConsultationModal, closeConsultationModal } from './modals'
import {
  ALERT,
  CLIENT_CREATED,
  CONTACT_FORM_SENT,
  NEWSLETTER_SIGNUP_SUCCESS
} from '../constants'

export function submitContact(data) {
  return (dispatch) =>
    axios
      .post('/contact', {
        ...data,
        location: data.location || window.location.href
      })
      .then(() => {
        dispatch(reset('contact'))
        dispatch({ type: CONTACT_FORM_SENT })
        dispatch({
          type: ALERT,
          klass: 'success',
          message: 'Message sent successfully',
          timeout: 4000
        })
      })
      .catch(() => {
        dispatch({
          type: ALERT,
          klass: 'danger',
          message: 'Error submitting form',
          timeout: 4000
        })
      })
}

export function createOffer(userId, data) {
  return (dispatch) =>
    axios
      .post(`/users/${userId}/offers`, data)
      .then(() => {
        dispatch(reset('offer'))
        dispatch(push('/offers'))
        dispatch({
          type: ALERT,
          klass: 'success',
          message: 'Thank you, we will be in touch soon',
          timeout: 10000
        })
      })
      .catch(({ message }) => {
        dispatch({ type: ALERT, klass: 'danger', message, timeout: 3000 })
      })
}

export function createTour(userId, data) {
  return (dispatch) =>
    axios
      .post(`/users/${userId}/tours`, data)
      .then(() => {
        dispatch(reset('tour'))
        dispatch(push('/scheduled-tours'))
        dispatch({
          type: ALERT,
          klass: 'success',
          message: 'Thank you, we will be in touch soon',
          timeout: 10000
        })
      })
      .catch(({ message }) => {
        dispatch({ type: ALERT, klass: 'danger', message, timeout: 3000 })
      })
}

export function signupNewsletter(data) {
  return (dispatch) =>
    axios
      .post('/newsletter_recipients', data)
      .then(() => {
        dispatch(reset('newsletter'))
        dispatch({ type: NEWSLETTER_SIGNUP_SUCCESS })
        dispatch({
          type: ALERT,
          klass: 'success',
          message: 'Thank you!',
          timeout: 4000
        })
      })
      .catch(() => {
        dispatch({
          type: ALERT,
          klass: 'danger',
          message: 'Network error',
          timeout: 4000
        })
      })
}

export function createClient(data) {
  return (dispatch) =>
    axios
      .post('/clients', data)
      .then((response) => {
        dispatch(reset(data.type))
        dispatch({ type: CLIENT_CREATED, client: response.data })
        dispatch(openConsultationModal())
      })
      .catch(() => {
        dispatch({
          type: ALERT,
          klass: 'danger',
          message: 'Network error',
          timeout: 4000
        })
      })
}

export function updateClient(id, data) {
  return (dispatch) =>
    axios
      .patch(`/clients/${id}`, data)
      .then(() => {
        dispatch(closeConsultationModal())
        dispatch(push('/'))
        dispatch({
          type: ALERT,
          klass: 'success',
          message: 'Thank you, we will be in touch soon',
          timeout: 10000
        })
      })
      .catch(() => {
        dispatch({
          type: ALERT,
          klass: 'danger',
          message: 'Network error',
          timeout: 4000
        })
      })
}

export function cancelClientUpdate() {
  return (dispatch) => {
    dispatch(closeConsultationModal())
    dispatch(push('/'))
  }
}



// WEBPACK FOOTER //
// ./src/actions/forms.js